import { AwsRum, AwsRumConfig } from 'aws-rum-web';

let awsRum: AwsRum | null = null;

// Initialize RUM only once
export const initRUM = () => {
  if (awsRum) return;

  try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1 ,
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID ,
    endpoint: process.env.REACT_APP_RUM_ENDPOINT ,
    telemetries: ["performance","errors","http"] ,
    allowCookies: true ,
    enableXRay: false ,
    signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID: string = process.env.REACT_APP_RUM_APPLICATION_ID as string;
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'ap-southeast-2';

  awsRum = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch (error) {
  console.warn('AWS RUM initialization failed:', error);
  // Ignore errors thrown during CloudWatch RUM web client initialization
}
}
// Use this safely in other files
export const getAwsRum = (): AwsRum | null => awsRum;

// Optional: Set session metadata
export const setRUMUser = (userId: string, metadata: Record<string, any> = {}) => {
  if (!awsRum) return;

  awsRum.addSessionAttributes({
    userId,
    ...metadata,
  });
};